<template>
  <EmptySubscriptionPage
    v-if="!hasFeatureFlag('module-products')"
    :text="{
      title: $t('upgrade_subscription_page.products.categories.title'),
      description: $t(
        'upgrade_subscription_page.products.categories.description'
      ),
      btnPrimary: $t('upgrade_subscription_page.upgrade_btn')
    }"
    imageName="products"
  />
  <Flex
    direction="column"
    v-else
  >
    <Page
      :query="GET_PRODUCT_CATEGORIES"
      :actions="{
        text: 'global.actions.create_category',
        route: 'products-create-category',
      }"
      :emptyPageContent="{
        route: 'products-create-category',
        title: $t('products.empty_state.categories.title'),
        description: $t('products.empty_state.categories.description'),
        btnPrimary: $t('global.actions.create_category'),
        imageName: 'products',
      }"
    >
      <CategoriesList />
    </Page>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import EmptySubscriptionPage from '@/modules/_shared/subscription/EmptySubscriptionPage.vue';
import { useUserStore } from '@/stores/user';
import Page from '../_shared/Page.vue';
import CategoriesList from './CategoriesList.vue';
import { GET_PRODUCT_CATEGORIES } from './graphql';

const { hasFeatureFlag } = useUserStore();
</script>
